// Third Party
import * as React from 'react';
import Image from 'next/image';

// Utils
import { imagekitLoader } from '@utils/imagekit-loader';
import { GRAY_PIXEL_DATA_URL } from '@utils/constants';
import { formatDollarAmount } from '../../utils/money';
import { GiftCard } from './types';

// UI
import { Icon, IconNames } from '@components/icon';
import placeholdImagePath from '../../../public/assets/img/gift-cards/gc_featured_1.jpg';

type Props = {
  giftCard: GiftCard;
  setGiftCard: (giftCard: GiftCard | undefined) => void;
};

export const GiftCardInfo: React.FC<Props> = ({ giftCard, setGiftCard }) => {
  return (
    <>
      <div
        className="w-full bg-gray-light py-5"
        style={{ marginTop: '3.5rem' }}
      >
        <div className="mx-auto grid grid-cols-4">
          <button
            onClick={() => setGiftCard(undefined)}
            style={{ outline: 'none' }}
            className="text-white hover:text-gray-light font-semibold flex flex-row items-center col-span-1 text-left lg:text-center"
          >
            <Icon name={IconNames.CHEVRON_LEFT} className="w-4 h-4 mr-2" />
            <span className="hidden lg:inline-block">Back to Lookup</span>
          </button>
          <div className="text-center col-span-2 text-white font-bold text-lg">
            {`#${giftCard.certificateNumber || ''}`}
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-b from-secondary-dark to-secondary-main">
        <div className="container mx-auto p-8 flex flex-col items-center lg:flex-row lg:justify-center lg:space-x-20">
          <div className="relative h-60 w-96 shadow-xl rounded-2xl">
            {giftCard.imageUrl ? (
              <Image
                layout="fill"
                src={giftCard.imageUrl}
                loader={imagekitLoader}
                alt="gift crad"
                placeholder="blur"
                className="rounded-2xl"
                blurDataURL={GRAY_PIXEL_DATA_URL}
                sizes="calc(96 * 4px)"
                lazyBoundary="400px"
              />
            ) : (
              <Image
                layout="fill"
                src={placeholdImagePath}
                alt="gift crad"
                placeholder="blur"
                className="shadow-xl rounded-2xl"
                sizes="calc(96 * 4px)"
                lazyBoundary="400px"
              />
            )}
          </div>

          <div className="grid grid-cols-2 gap-8 break-words lg:justify-self-start">
            <div className="py-4">
              <div>
                <p className="text-gray-light font-medium">Purchase Amount:</p>
                <p className="text-white font-semibold">
                  {`${formatDollarAmount(giftCard.orderAmountCents)}`}
                </p>
              </div>
              <div className="my-8">
                <p className="text-gray-light font-medium">Delivery Date:</p>
                {giftCard.verifiedAt && (
                  <p className="text-white font-semibold">
                    {new Date(giftCard.verifiedAt).toDateString()}
                  </p>
                )}
              </div>
            </div>
            <div className="py-4">
              <div>
                <p className="text-gray-light font-medium">Current Balance:</p>
                <p className="text-white font-semibold">
                  {`${formatDollarAmount(giftCard.currentBalanceCents)}`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
